export class VaultTypeFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<VaultType>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<VaultType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VaultTypeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
